import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import _ from 'lodash';

import ChannelCard from 'components/ChannelCard';
import Dropdown from 'components/Dropdown';
import Menu, { MenuItem } from 'components/Menu';
import { DownChevronIcon } from 'components/Svg';

export const ChannelSelectItem = ({channel, onSelect,...props}) => (
  <MenuItem className="g-channel-select-item" onClick={() => onSelect?.(channel._id, channel)} {...props}>
    <ChannelCard channel={channel} />
  </MenuItem>
)

export const ChannelSelect = ({ channels = [], className, size = 'm', selected, showAll = false, onChange,...props}) => {
  let onSelect = (channelId, channel) => onChange?.(channelId, channel)
  let selectedChannel = _.find(channels, { _id: selected });

  return (
    <Menu 
      target={({className: targetClassName, ...props}) => (
        <div className={cx("g-channel-select", className, size, targetClassName)} {...props}>
          {showAll && selected === null && <div className="all-channels">All Channels</div>}
          {!showAll && selected === null && <div className="select-text">Select Channel</div>}
          {selected !== null && <ChannelCard channel={selectedChannel} size={size} />}
          <DownChevronIcon />
        </div>
      )}
      position={'top left'}>
      <div className="g-channel-select-dropdown">
        {showAll && <MenuItem onClick={() => onSelect?.(null, null)}>All Channels</MenuItem>}
        {_.map(channels, channel => <ChannelSelectItem key={channel?._id} channel={channel} onSelect={onSelect} />)}
      </div>
    </Menu>)
}
export default ChannelSelect;